import { render } from "./notfound.html?vue&type=template&id=631b509f&scoped=true&external"
import script from "./notfound.js?vue&type=script&lang=js&external"
export * from "./notfound.js?vue&type=script&lang=js&external"

import "./notfound.css?vue&type=style&index=0&id=631b509f&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631b509f"]])

export default __exports__